import { TFunction } from 'i18next';
import TaskDTO from 'models/dto/tasks/taskDTO';
import ReportRequestDTO from './ReportRequestDTO';

export class ReportRequest16DTO extends ReportRequestDTO {
  taskColumns: string[];

  taskColumnsExcel: string[];

  chartSeriesLabels: string[];

  chartYAxisLabel: string;

  unAssignedUserName: string;

  tasks: TaskDTO[];

  constructor(report: ReportRequestDTO, t?: TFunction<string[]>) {
    super(report);
    this.taskColumns = [];
    this.taskColumnsExcel = [];
    this.chartSeriesLabels = [];
    this.chartYAxisLabel = '';
    this.unAssignedUserName = '';
    this.tasks = [];

    if (t) {
      this.taskColumns = [
        t('translation:General.EntityType.Task'),
        t('task:Description.Label'),
        t('tags:General.Name'),
        t('task:Assignment.Label'),
        t('task:Status.Label'),
        t('task:Start.Label'),
        t('task:Deadline.Label'),
        t('task:Pivot.Checklist'),
      ];

      this.taskColumnsExcel = [t('tasks:Reports.IsPartOfEvent')];

      this.chartSeriesLabels = [
        t('tasks:Reports.TaskStatusCompleted'),
        t('tasks:Reports.TaskStatusNotCompleted'),
        t('tasks:Reports.TaskStatusOverDeadline'),
      ];

      this.chartYAxisLabel = t('tasks:Reports.TaskCount');
      this.unAssignedUserName = t('tasks:Reports.UnAssignedUserName');
    }
  }

  clone(): ReportRequest16DTO {
    const output = new ReportRequest16DTO(this);
    output.tasks = [...this.tasks];
    output.taskColumns = [...this.taskColumns];
    output.taskColumnsExcel = [...this.taskColumnsExcel];
    output.chartSeriesLabels = [...this.chartSeriesLabels];
    output.chartYAxisLabel = this.chartYAxisLabel;
    output.unAssignedUserName = this.unAssignedUserName;

    return output;
  }
}
